import { Layout } from "components"
export const RsuTest = () => {
 return (
  <Layout>
   <h1 className="flex justify-center py-5 text-xl font-bold">RSU Test</h1>
  </Layout>
 )
}
